module.exports = __webpack_public_path__ + "media/images/index/service-icon-left-ee95f1f6e03a2900072e1fc80419fefd.svg";